import React from 'react';
import { arrayOf, number, shape, string } from 'prop-types';
import map from 'lodash/map';
import cx from 'classnames';
import { FormattedHTMLMessage } from 'react-intl';
import QuestionText from '../reusable/QuestionText';
import addExtraZero from '../helpers/addExtraZero';
import InputWithGroup from '../reusable/InputWithGroup';
import RadioBoxesWithInput from '../reusable/RadioBoxesWithInput';
import { fieldNames } from '../const';

const RecentCreditEnquiryQuestion = ({ otherLendersApplications, selectedValues }) => {
  const creditEnquiryOptions = [
    {
      title: 'followup.question.recentCreditEnquiry.yes',
      value: 'YES',
    },
    {
      title: 'followup.question.recentCreditEnquiry.no',
      value: 'NO',
    },
    {
      title: 'followup.question.recentCreditEnquiry.unsure',
      value: 'UNSURE',
    },
  ];

  return (
    <div className={cx(['followup__question-container', 'followup__question-container--no-border'])}>
      <QuestionText textId="followup.question.recentCreditEnquiry" />
      {
                map(otherLendersApplications, ({ lenderName, creditedAmount }, index) => {
                  const lenderId = lenderName.replaceAll(/[^A-Z0-9]+/ig, '');
                  const formValue = selectedValues.find((value) => value.lenderId === lenderId);
                  const answer = formValue && formValue.answer;
                  const shouldShowExtraPartOfQuestion = answer && answer !== 'NO';
                  return (
                    <div key={lenderName}>
                      <div
                        className={cx('followup__question-header', {
                          'followup__question-header--marginTop': index > 0,
                        })}
                      >
                        <FormattedHTMLMessage
                          id="followup.question.recentCreditEnquiry.lenderAmount"
                          values={{ amount: addExtraZero(creditedAmount), lenderName }}
                        />
                      </div>

                      <RadioBoxesWithInput
                        fieldName={`${fieldNames.creditEnquiry}-${lenderId}`}
                        options={creditEnquiryOptions}
                      />

                      {
                                shouldShowExtraPartOfQuestion && (
                                <React.Fragment>
                                  <QuestionText
                                    textId={
                                            answer === 'YES'
                                                ? 'followup.question.recentCreditEnquiry.expectedRepayments'
                                                : 'followup.question.recentCreditEnquiry.potentialExpectedRepayments'
                                        }
                                  />
                                  <InputWithGroup
                                    groupName={`${fieldNames.creditEnquiryFrequency}-${lenderId}`}
                                    inputName={`${fieldNames.creditEnquiryAmount}-${lenderId}`}
                                    errorValues={{ min: 0, max: 10000 }}
                                  />
                                </React.Fragment>
                                )
                            }
                    </div>
                  );
                })
            }
    </div>
  );
};

RecentCreditEnquiryQuestion.propTypes = {
  otherLendersApplications: arrayOf(shape({
    lenderName: string,
    creditedAmount: number,
  })),
  selectedValues: arrayOf(shape({
    lenderId: string,
    answer: string,
  })),
};

export default RecentCreditEnquiryQuestion;
